import { Button, Card, Container, Stack, styled, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { PATH_PAGE } from '../../routes/paths';
import Iconify from '../../components/Iconify';
import TextMaxLine from '../../components/TextMaxLine';
import useEvents from '../../hooks/useEvents';
import { getActiveEvents } from '../../utils/events';

const CardHeaderStyle = styled(Stack)(() => ({
  border: 0,
  width: '100%',
  backgroundColor: 'black',
}));

const CardStyle = styled(Card)(({ theme }) => ({
  textAlign: 'left',
  boxShadow: theme.customShadows.z64,
}));

export default function HomeLastNew() {
  const { events } = useEvents();
  const lastEvent = getActiveEvents(events).at(0) || null;

  return (
    <Container>
      {lastEvent && (
        <CardStyle elevation={10} sx={{ width: { xs: 1, md: 530 } }}>
          <CardHeaderStyle sx={{ px: 4, py: 1 }}>
            <Typography color="common.white" fontWeight="bold">
              DERNIÈRE NOUVELLE
            </Typography>
          </CardHeaderStyle>
          <Stack spacing={2} px={4} py={0.5}>
            <TextMaxLine line={2} color="#086043" variant="h5">
              {lastEvent?.title}
            </TextMaxLine>
            <TextMaxLine line={3} variant="h6" color="text.disabled">
              {lastEvent?.description}
            </TextMaxLine>
          </Stack>
          <Stack direction="row" justifyContent="flex-end" width={1} px={4} pb={0.5}>
            <Button
              component={RouterLink}
              to={PATH_PAGE.evenement}
              endIcon={<Iconify icon="ic:round-keyboard-arrow-right" sx={{ color: 'primary.main' }} />}
            >
              Lire plus
            </Button>
          </Stack>
        </CardStyle>
      )}
    </Container>
  );
}
